import { get } from "./apiService";

// ─── Interfaces ──────────────────────────────────────────────────────────────

export interface Feature {
  _id: string;
  key: string;
  name: string;
  category: {
    key: string;
    name: string;
  };
  platform: {
    web: boolean;
    mobile: boolean;
  };
  status: string;
  [key: string]: unknown;
}

export interface UserFeatures {
  platform: string[];
  businesses: Array<{
    businessId: string;
    businessName?: string;
    roleKey: string;
    roleName: string;
    features: Array<{
      key: string;
      name: string;
    }>;
  }>;
}

// ─── API Calls ──────────────────────────────────────────────────────────────

// V2 ENDPOINT: GET /api/v2/features
export const getFeatures = async (
  platform?: "web" | "mobile",
  category?: string
): Promise<Feature[]> => {
  const params: Record<string, unknown> = {};
  if (platform) params.platform = platform;
  if (category) params.category = category;
  return get<Feature[]>("/api/v2/features", params);
};

// V2 ENDPOINT: GET /api/v2/features (platform=web)
export const getWebFeatures = async (category?: string): Promise<Feature[]> => {
  return getFeatures("web", category);
};

// V2 ENDPOINT: GET /api/v2/user/me/features
export const getUserFeatures = async (
  platform?: "web" | "mobile"
): Promise<UserFeatures> => {
  const params: Record<string, unknown> = {};
  if (platform) params.platform = platform;
  return get<UserFeatures>("/api/v2/user/me/features", params);
};
